// Plain names for phones and computers ("Chrome on iPhone"), worked out from the
// browser's user agent, so a list of devices reads like the ones people own.

/** The kind of device: iPhone, iPad, Android phone, Mac, Windows computer, Chromebook or Linux computer. */
export function deviceKind(ua: string): string | null {
	if (/iPhone/.test(ua)) return "iPhone";
	if (/iPad/.test(ua)) return "iPad";
	if (/Android/.test(ua)) return /Mobile/.test(ua) ? "Android phone" : "Android tablet";
	if (/CrOS/.test(ua)) return "Chromebook";
	if (/Macintosh|Mac OS X/.test(ua)) return "Mac";
	if (/Windows/.test(ua)) return "Windows computer";
	if (/Linux/.test(ua)) return "Linux computer";
	return null;
}

/** "Chrome on Mac", or just "Mac" when the browser isn't one we know. */
export function deviceName(ua: string | null | undefined): string {
	if (!ua) return "A device we don't recognise";
	const kind = deviceKind(ua) ?? "A device we don't recognise";
	const browser = /Edg\//.test(ua)
		? "Edge"
		: /SamsungBrowser/.test(ua)
			? "Samsung Internet"
			: /Firefox|FxiOS/.test(ua)
				? "Firefox"
				: /Chrome|CriOS/.test(ua)
					? "Chrome"
					: /Safari/.test(ua)
						? "Safari"
						: null;
	return browser ? `${browser} on ${kind}` : kind;
}

/** A passkey's name as people read it. Older passkeys were named from navigator.platform ("MacIntel"). */
export function passkeyName(name: string | null | undefined): string {
	const n = (name ?? "").trim();
	if (!n || n === "This device") return "A device we don't recognise";
	if (/^Mac/.test(n)) return "Mac";
	if (/^Win/.test(n)) return "Windows computer";
	if (/^iPhone/.test(n)) return "iPhone";
	if (/^iPad/.test(n)) return "iPad";
	if (/^Linux arm|^Android/i.test(n)) return "Android phone";
	if (/^Linux/.test(n)) return "Linux computer";
	return n;
}
